import { AnimatedFormError, cn, Flex, Loading, Typography } from "djuno-design";
import { Control, Controller } from "react-hook-form";

import { AiJobsPresetImage } from "../../../types/ai";
import { CreateJobFormType } from "../../../pages/ai-trainings/AiJobCreatePage";
import { RadioGroup } from "@headlessui/react";
import { useEffect, useState } from "react";

//AiJob
export const AiJobsPresetImagesInput: React.FC<{
  control: Control<CreateJobFormType, any>;
  presetImages: AiJobsPresetImage[];
  errorMessage?: string;
  loading?: boolean;
}> = ({ control, presetImages, loading, errorMessage }) => {
  if (loading)
    return (
      <Flex items="center" justify="center" className="min-h-[200px]">
        <Loading borderSize={2} />
      </Flex>
    );

  return (
    <Flex direction="col" className="gap-3">
      <Controller
        name="selectedPresetImage"
        control={control}
        render={({ field: { value, onChange } }) => {
          return (
            <div className="w-full">
              <RadioGroup
                value={value || null}
                onChange={(presetImageId: string) => {
                  onChange(presetImageId);
                }}
              >
                <div className="grid gap-4 grid-cols-1 md:grid-cols-2 mb-5 mt-3">
                  {presetImages.map((presetImage, i) => {
                    return (
                      <RadioGroup.Option key={i} value={presetImage.id}>
                        {({ checked, disabled }) => {
                          return (
                            <div
                              className={cn(
                                "col-span-1 border-2 text-md rounded-xl dark:bg-dark-3 dark:border-gray-400/10 bg-white p-4 shadow hover:shadow-lg transition-all duration-300 cursor-pointer h-full",
                                {
                                  "border-primary-400 dark:border-primary-400":
                                    checked,
                                  "!cursor-not-allowed opacity-60": disabled,
                                }
                              )}
                            >
                              <div className="flex w-full justify-between items-center gap-2 h-9">
                                <Typography.Text className="!text-sm">
                                  {presetImage.name}
                                </Typography.Text>

                                <PresetImageItem presetImage={presetImage} />
                              </div>
                              <div className="flex items-center border-t border-slate-200 dark:border-gray-400/40 mt-2 pt-2 gap-0.5">
                                <Typography.Text className="!text-xs font-medium">
                                  {presetImage.description}
                                </Typography.Text>
                              </div>
                            </div>
                          );
                        }}
                      </RadioGroup.Option>
                    );
                  })}
                </div>
              </RadioGroup>
            </div>
          );
        }}
      />
      <AnimatedFormError error={errorMessage} />
    </Flex>
  );
};

const PresetImageItem = ({
  presetImage,
}: {
  presetImage: AiJobsPresetImage;
}) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [presetImage.logo]);

  if (!presetImage.logo) {
    return null;
  }

  if (hasError) {
    return (
      <span className="text-black dark:text-gray-50 text-sm">
        {presetImage.name}
      </span>
    );
  }

  return (
    <img
      src={presetImage.logo}
      alt={presetImage.name}
      onError={() => setHasError(true)}
      className="h-full"
    />
  );
};
